import { useState } from "react";
import { CalendarDays, ChevronUp } from "lucide-react";
import FileUpload from "./FileUpload";

export default function TrainingAccordion({
  initialTitle,
  initialValidFrom,
  initialExpiry,
  initialComment,
  initialAttachment,
  onDelete,
  onUpdate,
}) {
  const [isOpen, setIsOpen] = useState(true);
  const [title, setTitle] = useState(initialTitle);
  const [validFrom, setValidFrom] = useState(initialValidFrom?.slice(0, 10));
  const [expiry, setExpiry] = useState(initialExpiry?.slice(0, 10));

  const [comment, setComment] = useState(initialComment);
  const [attachment, setAttachment] = useState(initialAttachment);

  const handleFileChange = (url) => {
    setAttachment(url);
    onUpdate?.({ title, validFrom, expiry, comment, attachment: url });
  };

  const handleRemove = () => {
    onDelete?.();
  };

  return (
    <div className="rounded-md border border-gray-200 bg-white p-2">
      <div
        className="flex justify-between items-center cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <input
          type="text"
          value={title}
          onChange={(e) => {
            setTitle(e.target.value);
            onUpdate?.({
              title: e.target.value,
              validFrom,
              expiry,
              comment,
              attachment,
            });
          }}
          className="font-semibold text-sm border-none focus:outline-none focus:ring-0 bg-transparent w-full"
        />
        <ChevronUp
          className={`w-4 h-4 transform transition-transform ${
            isOpen ? "rotate-0" : "rotate-180"
          }`}
        />
      </div>

      {isOpen && (
        <div className="mt-4 space-y-4">
          {/* Dates */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Valid from
              </label>
              <div className="relative">
                <input
                  type="date"
                  value={validFrom}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    setValidFrom(newValue);
                    onUpdate?.({
                      title,
                      validFrom: newValue,
                      expiry,
                      comment,
                      attachment,
                    });
                  }}
                  className="appearance-none w-full border border-gray-300 rounded-md px-3 py-2 text-sm bg-white"
                  style={{ WebkitAppearance: "none" }}
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Expiry
              </label>
              <div className="relative">
                <div className="relative">
                  <input
                    type="date"
                    value={expiry}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setExpiry(newValue);
                      onUpdate?.({
                        title,
                        validFrom,
                        expiry: newValue,
                        comment,
                        attachment,
                      });
                    }}
                    className="appearance-none w-full border border-gray-300 rounded-md px-3 py-2 text-sm bg-white"
                    style={{ WebkitAppearance: "none" }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Comment */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Comment
            </label>
            <textarea
              rows="3"
              placeholder="Add a comment..."
              value={comment}
              onChange={(e) => {
                const newValue = e.target.value;
                setComment(newValue);
                onUpdate?.({
                  title,
                  validFrom,
                  expiry,
                  comment: newValue,
                  attachment,
                });
              }}
              className="w-full rounded-md border border-gray-300 px-4 py-2 text-sm focus:outline-none focus:ring-2 transition placeholder-gray-400 resize-none"
            />
          </div>

          {/* Attachment + Actions */}
          <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2">
            <FileUpload
              title={title}
              attachment={attachment} // the server path string, e.g. "uploads/file.pdf"
              onChange={handleFileChange}
              onRemove={handleRemove}
            />
            <div className="flex items-center mr-2 mt-2">
              <button
                onClick={handleRemove}
                className="text-sm font-medium text-red-600 hover:underline"
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
